<template>
  <g transform="matrix(1 0 0 1 0 0)">
    <path
      d="M1 7.22222L5.71018 12.9464C6.556 13.9743 8.15119 13.9045 8.90401 12.8067L17 1"
      stroke="#FFFEF4"
      stroke-width="1.8"
    />
  </g>
</template>
